export const INK_COLORS = {
  Amber: { class: 'ink-amber', bg: 'bg-ink-amber', text: 'text-ink-amber', glow: 'ink-glow-amber', dot: 'bg-ink-amber' },
  Amethyst: { class: 'ink-amethyst', bg: 'bg-ink-amethyst', text: 'text-ink-amethyst', glow: 'ink-glow-amethyst', dot: 'bg-ink-amethyst' },
  Emerald: { class: 'ink-emerald', bg: 'bg-ink-emerald', text: 'text-ink-emerald', glow: 'ink-glow-emerald', dot: 'bg-ink-emerald' },
  Ruby: { class: 'ink-ruby', bg: 'bg-ink-ruby', text: 'text-ink-ruby', glow: 'ink-glow-ruby', dot: 'bg-ink-ruby' },
  Sapphire: { class: 'ink-sapphire', bg: 'bg-ink-sapphire', text: 'text-ink-sapphire', glow: 'ink-glow-sapphire', dot: 'bg-ink-sapphire' },
  Steel: { class: 'ink-steel', bg: 'bg-ink-steel', text: 'text-ink-steel', glow: 'ink-glow-steel', dot: 'bg-ink-steel' },
} as const;

export type InkColor = keyof typeof INK_COLORS;

export function getInkStyle(ink: InkColor) {
  return INK_COLORS[ink] || INK_COLORS.Amber;
}
